$(document).ready(function () {
  window.App = {
    init: function () {
      window.App.headerNav = new Navigation({
        toggle: "nav-button",
        nav: "nav-container",
        subnav: "nav-section",
        openText: "Open Navigation Menu",
        closedText: "Close Navigation Menu",
      }).init();

      window.App.myLocation = new MyLocation();

      window.App.externalPopup = new ExternalPopup();
      window.App.externalPopup.init();

      window.App.menuNav = new Navigation({
        toggle: "category-header__nav-toggle",
        nav: "category-nav",
        openText: "Open Food Category Navigation",
        closedText: "Close Food Category Navigation",
      }).init();

      // /menu/wings/more functionality
      const $htmlBody = $('html, body');
      const $foodTile = $('.js-food-tile');
      const $foodTileBtn = $('.js-food-tile-btn');
      const $foodTileCloseBtn = $('.js-food-tile-overlay-close-btn');
      const $foodTileOverlay = $('.js-food-tile-overlay');
      const $foodSlider = $('.js-food-slider');
      const $foodSliderDotsContainer = '.c-food-slider__dots-container';

      //Slider on wings and more page.
      $foodTileBtn.on('click', function(e) {
        e.preventDefault();
        const elTop = $(this).parent().offset().top;
        $(this)
        .closest($foodTile)
        .find($foodTileOverlay)
        .addClass('active');
        $htmlBody.animate({scrollTop: elTop}, 300);
      });

      $foodTileCloseBtn.on('click', function(e) {
        e.preventDefault();
        $(this)
        .closest($foodTile)
        .find($foodTileOverlay)
        .removeClass('active');
      });

      $foodSlider.slick({
        infinite: true,
        appendDots: $foodSliderDotsContainer,
        dots: true,
        speed: 400,
        slidesToShow: 1,
        adaptiveHeight: true,
        fade: true,
      });

      if ($(".js-countdown").length > 0) {
        window.App.countdowns = [];
        $(".js-countdown").each(function (index, element) {
          window.App.countdowns[index] = new Countdown(element);
        });
      }
    },
  };

  window.App.init();
});
